<script>
export default {
  name: "CarouselSlide",
  props: {
    productSlide: {
      type: Boolean,
      required: false,
      default: false
    },
    separator: {
      type: Boolean,
      required: false,
      default: false
    },
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    diapoNumber: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    ariaLabel() {
      return this.diapoNumber ? "Diapo " + this.diapoNumber : null;
    }
  }
};
</script>

<template>
  <swiper-slide
    class="swiper-slide c-carousel__slide"
    :class="[
      productSlide && 'c-carousel__slide--product',
      separator && 'c-carousel__slide--separator'
    ]"
    role="group"
    aria-roledescription="Diapo"
    :aria-label="ariaLabel"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
  >
    <slot />
  </swiper-slide>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/carousel.scss";
</style>
